import { call, select } from 'redux-saga/effects'
import {getUserIdentity} from "state/app/selectors";
import {openEmail} from "lib/native";

export default function* openEmailSaga(action) {
  const userIdentity = yield select(getUserIdentity);
  return yield call(openEmail, userIdentity.get("platform"), action.payload.emailAddress);
}



// WEBPACK FOOTER //
// ./src/state/app/sagas/openEmail.js